import { useParams } from 'react-router-dom';

import Meeting from '@/components/Meeting/Meeting';
import useSharedPublicMeeting from '@/hooks/useSharedPublicMeeting';
import PageContainer from '@/pages/PageContainer';

const SharedPublicMeeting = () => {
  const { sharedMeetingId } = useParams();
  const { sharedMeetingData } = useSharedPublicMeeting(sharedMeetingId!);

  return (
    <PageContainer isBackButtonVisible={false} sx={{ paddingLeft: 0 }}>
      <Meeting
        sharedMeeting
        event={sharedMeetingData?.event}
        meetingRecordingUrl={sharedMeetingData?.recordingUrl}
        meetingTranscriptUrl={sharedMeetingData?.transcriptUrl}
        meeting={sharedMeetingData?.meeting}
        meetingAnalysis={sharedMeetingData?.meetingAnalysis?.[0]}
      />
    </PageContainer>
  );
};

export default SharedPublicMeeting;
